import React, {useState} from 'react'
import ITwi  from 'static/img/iTwi'
import IInst from 'static/img/iInst'
import './footer.scss'

const Footer = () => {
  return (
    <footer className={'footer-wrapper'}>
      <small>&copy; Y.HASEGAWA</small>
    </footer>
  )
}

export default Footer
